<template>
  <div class="password">
    <IconSwitch :type="'qrcode'"></IconSwitch>
    <Icon></Icon>
    <el-collapse-transition>
      <Error v-if="errorShow" :msg="errorMsg" v-on:closeErrorTip="closeErrorTip"></Error>
    </el-collapse-transition>
    <Account :content="account"></Account>
    <Inputs :type="'password'" v-on:inputText="getPassword" v-on:rememberpw="getRememberpw" v-on:enterInput="enterInput" :remember="{password, rememberpw}"></Inputs>
    <Buttons ref=btn :type="'login'" style="margin-top: 60px;" :style="{marginBottom: (!isEmail && !isPhone ? '80px' : '')}" :data="{type: type, password: password, account: account}" v-on:openErrorTip="openErrorTip" v-on:closeErrorTip="closeErrorTip" v-on:loginSuccess="loginSuccess"></Buttons>
    <!-- <button @click="login" :style="{cursor: (!loading ? 'pointer' : 'not-allowed'), marginBottom: (!isEmail && !isPhone ? '80px' : '')}">
      <span v-show="!loading">Sign in</span>
      <img v-show="loading" class="rolling" src="../../assets/images/new-login-2018/rolling.gif">
    </button> -->
    <Foot :type="'Forgot password'" :isEmail="isEmail ? true : false" style="margin-top: 50px;margin-bottom: 35px;" v-show="isEmail || isPhone"></Foot>
  </div>
</template>

<script>
  import IconSwitch from '../components/Iconswitch'
  import Icon from '../components/Icon'
  import Error from '../components/Error'
  import Account from '../components/Account'
  import Inputs from '../components/Inputs'
  import Buttons from '../components/Buttons'
  import Foot from '../components/Foot'
  import RememberPassword from '../common/RememberPassword.js'
  import { checkEmail, checkPhone, checkUsername } from '../common/Common.js'
  import { errorFn } from '../common/ErrorMsg.js'
  export default {
    data () {
      return {
        loading: false,
        errorShow: false,
        errorMsg: '',
        type: 0,
        rememberPassword: '',
        account: this.$route.query.account,
        password: '',
        rememberpw: false,
        isEmail: checkEmail(this.$route.query.account),
        isPhone: checkPhone(this.$route.query.account),
        isAccount: checkUsername(this.$route.query.account)
      }
    },
    components: {
      IconSwitch, Icon, Error, Account, Inputs, Buttons, Foot
    },
    created () {
      this.rememberPassword = new RememberPassword()
      console.log(this.account)
      this.password = this.rememberPassword.getPassword(this.account)
      console.log(this.password)
      if (this.password !== '') {
        this.rememberpw = true
      }
    },
    mounted () {
      if (this.isEmail) {
      } else if (this.isPhone) {
        this.type = 1
      } else if (this.isAccount) {
        this.type = 2
      }
    },
    methods: {
      // 获取密码
      getPassword (data) {
        this.password = data
      },
      // 获取记住密码状态
      getRememberpw (data) {
        this.rememberpw = data
      },
      // 关闭错误提示
      closeErrorTip () {
        errorFn.closeErrorTip(this)
      },
      // 弹出错误提示
      openErrorTip (msg) {
        errorFn.openErrorTip(msg, this)
      },
      enterInput () {
        this.$refs.btn.clickBtn()
      },
      // 登录成功回调
      loginSuccess (password) {
        this.rememberPassword.savePassword(password, this.rememberpw)
        location.href = '../web/index.html'
      }
    }
  }
</script>

<style lang="less" scoped>
	@import '../../assets/css/_mixin.less';
  .password {
    .white-bg();
    min-height: 420px;
    margin-top: -210px;
    button {
      font-size: 14px;
      width: 300px;
      height: 40px;
      color: #ffffff;
      margin-top: 60px;
      margin-left: -19px;
      padding: 10px;
      background: #3f86de;
      border: 1px solid #3f86de;
      border-radius: 2px;
      cursor: pointer;
      .rolling {
        margin-top: -7px;
        outline: none;
        width: 30px;
        height: 30px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Password.vue?26eb3c0c